import { InitiativeReference } from '@types';
import { SyncState } from '@sonar-software/xuder';

export type InitiativesIdMapState = SyncState<Record<number, InitiativeReference>>;

export const defaultInitiativesIdMapState: InitiativesIdMapState = { data: {} };
